module.exports = __webpack_public_path__ + "img/slika58.dfa85979.jpg";